export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8984.5676bf00.jpg";